import { FC, useMemo } from "react";

import { CreateGMWEventTask, EditGMWEventTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GmwEventFormProps } from "@/types/form-types";

import { useGmwUiSchema } from "../../schema/gmw-ui-schema";
import { validateGmwFormUnified } from "../../schema/gmw-validation";

import { gmwEventFormSchema } from "./schema";

const GmwEventForm: FC<GmwEventFormProps> = (props) => {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();

  const { oldUploadTask, task, type } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    CreateGMWEventTask | EditGMWEventTask
  >({ key: "gmwEvent", task });

  // Add attribute original event date, if isEditing is true

  const uiSchema = useGmwUiSchema(formData?.metadata.qualityRegime);

  const schema = useMemo(() => gmwEventFormSchema({ type, isEditing }), [type, isEditing]);

  const onSubmit = async () => {
    if (!formData) return;
    await (getIsEditing(formData) ? api.editGMWEvent(formData) : api.createGMWEvent(formData));
    // Remove the old upload task
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm<CreateGMWEventTask | EditGMWEventTask>
      uploadTask={oldUploadTask}
      schema={schema}
      formData={formData}
      onChange={handleChange}
      uiSchema={uiSchema}
      onSubmit={onSubmit}
      customValidate={validateGmwFormUnified}
    />
  );
};
export { GmwEventForm };
